var myTheme = {
    link: '#34657f',
    body: {
        text: '#333333'
    },
    field: {
        focus: '#3e8529'
    },
    button: {
        primary: {
            text: '#FFFFFF',
            hover: '#3e8529'
        },
        secondary: {
            hover: '#FFFFFF'
        },
        text: '#34657F',
        background: '#3e8529'
    },
    footer: {
        background: '#FFFFFF',
        text: '#000'
    },
    radio: {
        border: '#34657F',
        background: '#34657F',
        inactiveBorder: '#656565',
        focusBackground: '#CECFD1'
    }
};
export default myTheme;
